import React from "react";

export const PushTestButton: React.FC = () => {
  // const handleClick = async () => {
  //   let perm = Notification.permission;
  //   if (perm !== "granted") {
  //     perm = await Notification.requestPermission();
  //   }

  //   if (perm !== "granted") {
  //     alert("❌ Musisz włączyć powiadomienia, aby to zadziałało.");
  //     return;
  //   }

  //   const reg = await navigator.serviceWorker.getRegistration();

  //   if (reg) {
  //     await reg.showNotification("🔥 Mega Test PWA", {
  //       body: "Kliknij, aby wrócić do swojego sklepu.",
  //       icon: "/logo512.png",
  //       badge: "/logo192.png",
  //       requireInteraction: true,
  //       vibrate: [200, 100, 200, 100, 300],
  //       data: { url: "/testApp/login?id=1241" }, // 👈 dodaj własny link
  //       actions: [
  //         { action: "open", title: "➡️ Otwórz aplikację" },
  //         { action: "close", title: "❌ Zamknij" },
  //       ],
  //       tag: "test-aggressive",
  //       renotify: true,
  //     } as any);
  //   } else {
  //     new Notification("🔥 Mega Test PWA", {
  //       body: "Fallback notyfikacja (brak service workera).",
  //       icon: "/logo512.png",
  //     });
  //   }
  // };

  return (
    <>
      {/* <button
      onClick={handleClick}
      style={{
        background: "linear-gradient(90deg,#ff4d4d,#cc0000)",
        color: "#fff",
        padding: "1rem 2rem",
        borderRadius: "12px",
        fontSize: "1rem",
        fontWeight: "bold",
        border: "none",
        cursor: "pointer",
        marginTop: "1rem",
        width: "100%",
      }}
    >
      🔔 Przetestuj agresywne powiadomienie
    </button> */}
      {/* <PushAutoTest/> */}
    </>
  );
};
